import { combineReducers } from 'redux';
import {
  FETCH_SIGNUP_PAGES_REQUEST,
  FETCH_SIGNUP_PAGES_SUCCESS,
  FETCH_SIGNUP_PAGES_FAILURE,
  FETCH_SIGNUP_PAGE_BY_ID_REQUEST,
  FETCH_SIGNUP_PAGE_BY_ID_SUCCESS,
  FETCH_SIGNUP_PAGE_BY_ID_FAILURE,
  SIGNUP_PAGE_SELECTED_CLEAR,
} from '../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SIGNUP_PAGES_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SIGNUP_PAGES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_SIGNUP_PAGES_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SIGNUP_PAGE_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SIGNUP_PAGE_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_SIGNUP_PAGE_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case SIGNUP_PAGE_SELECTED_CLEAR:
      return { data: {}, isFetching: false, errorMessage: null };
    default:
      return state;
  }
};

const signupPage = combineReducers({
  list,
  selected,
});

export default signupPage;
